import { render, staticRenderFns } from "./CTwoRow.vue?vue&type=template&id=20d313d5&scoped=true&"
import script from "./CTwoRow.vue?vue&type=script&lang=js&"
export * from "./CTwoRow.vue?vue&type=script&lang=js&"
import style0 from "./CTwoRow.vue?vue&type=style&index=0&id=20d313d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d313d5",
  null
  
)

export default component.exports